import { Phone, Mail, MapPin, Briefcase, IdCard, Cake, HeartPulse, Repeat, Smile } from "lucide-react";
import { brl, fmtDate, age } from "@/lib/constants";
import { ReturnBadge } from "@/components/StatusBadge";

const Row = ({ icon: Icon, label, value, testId }) => (
  <div className="flex items-start gap-3 py-2.5">
    <Icon className="mt-0.5 h-4 w-4 text-sky-500" />
    <div>
      <p className="text-xs font-semibold text-slate-400">{label}</p>
      <p className="text-sm font-medium text-slate-800" data-testid={testId}>{value || "—"}</p>
    </div>
  </div>
);

const returnStatus = (d) => {
  if (!d) return "sem_data";
  const t = new Date().toISOString().slice(0, 10);
  if (d < t) return "vencido";
  const in30 = new Date(Date.now() + 30 * 864e5).toISOString().slice(0, 10);
  return d <= in30 ? "proximo" : "em_dia";
};

export const DadosTab = ({ p }) => (
  <div className="grid gap-5 lg:grid-cols-3">
    <div className="surface p-5 lg:col-span-2">
      <h3 className="font-display mb-2 text-lg font-bold text-slate-900">Dados pessoais</h3>
      <div className="grid gap-x-8 sm:grid-cols-2">
        <Row icon={Phone} label="Telefone / WhatsApp" value={p.phone} testId="patient-detail-phone" />
        <Row icon={Mail} label="E-mail" value={p.email} />
        <Row icon={IdCard} label="CPF / RG" value={[p.cpf, p.rg].filter(Boolean).join(" · ")} />
        <Row icon={Cake} label="Nascimento" value={p.birth_date ? `${fmtDate(p.birth_date)} (${age(p.birth_date)} anos)` : ""} />
        <Row icon={Briefcase} label="Profissão" value={p.profession} />
        <Row icon={HeartPulse} label="Contato de emergência" value={p.emergency_contact} />
        <Row icon={MapPin} label="Endereço" value={p.address} />
      </div>
      {p.notes && <p className="mt-3 rounded-xl bg-slate-50 p-3 text-sm text-slate-600">{p.notes}</p>}
    </div>
    <div className="space-y-5">
      <div className="surface p-5" data-testid="patient-ortho-card">
        <div className="flex items-center gap-2"><Smile className="h-5 w-5 text-cyan-600" /><h3 className="font-display font-bold text-slate-900">Aparelho ortodôntico</h3></div>
        {p.ortho?.active ? (
          <div className="mt-3 text-sm text-slate-600">
            <p className="font-display text-2xl font-extrabold text-slate-900">{brl(p.ortho.monthly_fee)}<span className="text-sm font-medium text-slate-400">/mês</span></p>
            <p>Vence todo dia <b>{p.ortho.due_day}</b></p>
            {p.ortho.start_date && <p>Início em {fmtDate(p.ortho.start_date)}</p>}
          </div>
        ) : <p className="mt-2 text-sm text-slate-400">Sem mensalidade de aparelho</p>}
      </div>
      <div className="surface p-5" data-testid="patient-return-card">
        <div className="flex items-center gap-2"><Repeat className="h-5 w-5 text-sky-600" /><h3 className="font-display font-bold text-slate-900">Retorno</h3></div>
        {p.return_plan?.active ? (
          <div className="mt-3 space-y-1 text-sm text-slate-600">
            <p>A cada <b>{p.return_plan.interval_months}</b> meses</p>
            <p>Próximo: <b>{fmtDate(p.return_plan.next_date)}</b></p>
            <ReturnBadge status={returnStatus(p.return_plan.next_date)} />
          </div>
        ) : <p className="mt-2 text-sm text-slate-400">Sem plano de retorno</p>}
      </div>
    </div>
  </div>
);
